import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";


// COPY LOCKED — do not paraphrase without client confirmation. See /app/memory/PRD.md.


export default function Footer() {
    return (
        <footer className="bg-charcoal text-offwhite" data-testid="site-footer">
            <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-16 md:pt-20 pb-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20">
                    <div>
                        <Logo variant="footer" brand="lrs" />
                        <p className="mt-4 font-manrope font-semibold text-[13px] tracking-widest uppercase opacity-70">
                            Design-led home renovation
                        </p>
                    </div>
                    <div className="md:justify-self-end">
                        <h4 className="font-manrope font-semibold text-[13px] tracking-widest uppercase opacity-60 mb-4">Company</h4>
                        <ul className="space-y-3 text-[15px] text-offwhite/80">
                            <li><a href="https://studio-g4.co.uk" target="_blank" rel="noopener noreferrer" className="hover:text-terracotta transition-colors" data-testid="footer-link-our-work">Our Work ↗</a></li>
                            <li><Link to="/faqs" className="hover:text-terracotta transition-colors" data-testid="footer-link-faqs">FAQs</Link></li>
                            <li><Link to="/privacy" className="hover:text-terracotta transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link></li>
                            <li><Link to="/free-design-terms" className="hover:text-terracotta transition-colors" data-testid="footer-link-terms">Free Design Terms</Link></li>
                            <li><Link to="/cookies" className="hover:text-terracotta transition-colors" data-testid="footer-link-cookies">Cookie Notice</Link></li>
                        </ul>
                    </div>
                </div>


                <div className="mt-14 pt-6 border-t border-offwhite/10 flex justify-end text-[12.5px] text-offwhite/50">
                    <p data-testid="footer-copyright">© 2026 London Renovation Specialists (LRS is a trading name of Studio G4 Ltd)</p>
                </div>
            </div>
        </footer>
    );
}
